import http from '@plugin/axios'

export function releaseInquiry(id: string | number) {
  return http({
    url: '/srmInquiry/releaseInquiry',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id }
  })
}

export function revokeInquiry(id: string | number) {
  return http({
    url: '/srmInquiry/revokeInquiry',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id }
  })
}

export function getTempGoodsNo() {
  return http({
    url: '/srmInquiry/getTempGoodsNo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {}
  })
}

export function getTaxExchangeRateByNo(taxTypeNo: string) {
  return http({
    url: '/srmTaxExchangeRate/getTaxExchangeRateByNo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      taxTypeNo
    }
  })
}

export function getSrmSupplierProtocolById(id: string | number) {
  return http({
    url: '/supplierProtocol/getSrmSupplierProtocolById',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      id
    }
  })
}

export function getInquiryDetail(id: string | number) {
  return http({
    url: '/srmInquiry/getInquiryDetail',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      id
    }
  })
}

export function abandon(asnNo: string | number, status: string | number) {
  return http({
    url: '/srmAsn/invalidAsnNo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      asnNo,
      status
    }
  })
}
